import './zod-config';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './styles/tokens.css';
import './styles/base.css';
import { Providers } from './app/Providers';
import { createAppRouter } from './app/router';
import { initI18n } from './i18n';

/** Startet die Anwendung: zuerst Sprache initialisieren, dann Oberfläche rendern. */
async function bootstrap(): Promise<void> {
  await initI18n();
  const container = document.getElementById('root');
  if (!container) throw new Error('Wurzelelement #root fehlt in index.html');
  createRoot(container).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={createAppRouter()} />
      </Providers>
    </StrictMode>,
  );
}

void bootstrap();
